import dayjs from 'dayjs';
import React from 'react';

import { AppDeviceLeaf } from 'types/common/leaf';

interface VideoScreenshotParams {
  leaf: AppDeviceLeaf;
  canvasRef: React.RefObject<HTMLCanvasElement>;
  videoRef: React.RefObject<HTMLVideoElement>;
}

interface VideoScreenshotReturn {
  takeScreenshot: () => void;
  downloadScreenshot: (name: string) => void;
}

export const useVideoScreenshot = ({ leaf, canvasRef, videoRef }: VideoScreenshotParams): VideoScreenshotReturn => {
  const canvas = canvasRef.current;
  const video = videoRef.current;

  const takeScreenshot: VideoScreenshotReturn['takeScreenshot'] = () => {
    if (canvas && video) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const context = canvas.getContext('2d') as CanvasRenderingContext2D;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
    }
  };

  const downloadScreenshot: VideoScreenshotReturn['downloadScreenshot'] = () => {
    if (canvas) {
      const dateString = dayjs().format('MM-DD-YYYY_HH-mm-ss');

      const dataURL = canvas.toDataURL('image/jpeg', 1.0);
      const link = document.createElement('a');
      link.id = `${leaf.name}-download-screenshot`;
      link.href = dataURL;
      link.download = `${leaf.name}_${dateString}.jpeg`;
      link.click();
    }
  };

  return { takeScreenshot, downloadScreenshot };
};
